import {ModuleEnum} from 'src/api/ProactApiClient';
import {useModulePermissions} from './useModulePermissions';

/**
 * Hook for Client/Site module permissions. Sites are managed under the same
 * ModuleEnum.Clients module (there is no standalone Sites module enum), so
 * this hook backs permission checks for both Client and Site pages/tables.
 * No custom operations beyond the standard + common set.
 */
export function useClientPermissions() {
  return useModulePermissions(ModuleEnum.Clients);
}
